import { render, staticRenderFns } from "./BugSidebar.vue?vue&type=template&id=cefb7fa0"
import script from "./BugSidebar.vue?vue&type=script&lang=js"
export * from "./BugSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports